import inputWithOptionsDriverFactory from '../InputWithOptions/InputWithOptions.driver';

const autoCompleteDriverFactory = inputWithOptionsDriverFactory;

export default autoCompleteDriverFactory;
